export default "__VITE_ASSET__CDpFTNcf__"